import React from "react"
import styled, { withTheme } from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"
import Container, { Row, Quarter, ThreeQuarter, Full, Third, TwoThird } from "../layout/container"
import Logo from "../../images/logo.svg"

// import LogoDark from "../../images/logodark.svg"
// import Facebook from "../../images/facebook.svg";
// import LinkedIn from "../../images/linkedin.svg";
// import Twitter from "../../images/twitter.svg";
// import Insta from "../../images/insta.svg";
import Subscribe from "../ui/subscribe";
// import Container, { Row, Third, TwoThird } from "../layout/container"


interface IProps {
  theme: {
    colors: {
      primary: string
      light: string
      dark: string
    }
  }
}

// const Container = styled.div`
//   max-width: 1200px;
//   //max-width: 90%;
//   margin: 0 auto;
//   padding: 0 5%;
// `;



const Footer = ({ theme }: IProps) => {

  const data = useStaticQuery(graphql`{
      contentfulOpeningTimes {
        openingTimes {
          openingTimes
        }
      }

    }
  `)
  // const Container = styled.div`
  //   padding: 0 5%;
  //   float: left;
  // `;
  const Wrapper = styled.div`
    max-width: 1200px;
    //max-width: 90%;
    margin: 0 auto;
    padding: 0 5%;
  `


  const ContainerRowTop = styled.div`

    border-top: 3px solid ${(props) => props.theme.colors.primary};
    padding-top: 2rem;
    margin-top: 2rem;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    
    @media screen and (max-width: 576px) {
      flex-direction: column;
    }
    @media screen and (max-width: 1024px) {
      flex-direction: column;
    }

    .mobile-sub {
      display: none;
      @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
        display: block;
        form {
          display: flex;
          input:first-of-type {
            flex: 30%;
          }
        }
      }
    }
  `

  const ContainerRow = styled.div`
    padding-bottom: 1.5rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;
    
    @media screen and (max-width: 576px) {
      flex-direction: row !important;
    }
    @media screen and (max-width: 1024px) {
      //flex-direction: column;
    }
  `
  const TwoThirdsPage = styled.div`
    width: 70%;
    @media screen and (max-width: 1024px) {
      width: 100%;
    }
  `

  const ThirdPage = styled.div`
    width: 30%;
    svg {
          width: 200px;
          padding-bottom: 1rem;
          @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
              width: 80px;
              padding-bottom: 1rem;
          }
    }

    @media screen and (max-width: 1024px) {
      width: 50%;
    }
  `

    const ThirdPageFootLeft = styled.div`
      width: 30%%;
      @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
          width: 25% !important;
      }
      svg {
            width: 200px;
            padding-bottom: 1rem;
            @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
                width: 80px;
                padding-bottom: 1rem;
            }
      }

      @media screen and (max-width: 1024px) {
        width: 50%;
      }
  `

      const ThirdPageFootRight = styled.div`
      width: 30%;
      @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
          width: 70% !important;
          li {
            display: inline-block !important;
            a {
                font-size: 0.5rem !important;
            }
          }
      }
      
      @media screen and (max-width: 1024px) {
        width: 50%;
      }
  `

  const Foot = styled.footer`
    border-bottom: 12px solid ${(props) => props.theme.colors.primary};
    .sub {
      @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
        display: none;
      }
    }
    
  `
  const TopFooter = styled.div`
    padding-right: 3rem;
    display: flex;
    justify-content: flex-end;
    @media screen and (max-width: ${props => props.theme.breakpoints.tablet}) {
      justify-content: space-between;
    }
    margin-bottom: 7rem;
    font-family: ${(props) => props.theme.fontCondensed};
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
      display: grid;
      grid-template-columns: 1fr 1fr;
    }
    
      ul {
        display: inline-block;
        padding: 0 1rem 0 0;
        :first-child {
          padding: 0 2rem 0 0;
        }
        li {
          a {
            text-decoration: none;
            &.underline {
              text-decoration: underline;
            }
          }
          :first-child {
            font-size: 0.6rem;
            padding-bottom: 0.5rem;
          }
          list-style: none;
        }
      }
      .opening {
          -webkit-user-modify: read-write-plaintext-only;
        }
  `
  const Links = styled.ul`
    margin-top: 0;
    margin-bottom: 1rem;
    width: 230px;
    @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
     width: auto;
    }
    @media screen and (max-width: ${props => props.theme.breakpoints.large}) {
      padding: 0 0 0rem 0;
    }
    li {
      display: inline-block;
      // padding: 0 0.5rem 0 0.5rem;
      @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
        display: block;
        a {
          // border-right: none !important;
          // padding: 0 !important;
        }
      }
      a {
        text-decoration: none;
        transition: 0.2s;
        font-size: 0.6rem;
        border-right: 1px solid ${(props) => props.theme.colors.primary};
        padding: 0 0.5rem 0 0.5rem;
        &.last-link {
          border-right: none;
        }
        &.first-link {
          border-right: none;
        }

      }
      &:first-child {
        //margin-left: -0.5rem;
        @media screen and (max-width: ${props => props.theme.breakpoints.phone}) {
          margin-left: 0;
        }
        // border-right: 2px solid ${(props) => props.theme.colors.primary};
      }
      //   &:last-child {
      //   border-right: none;
      // }
    }
  `

  const FutureButton = styled.div`
    position: fixed;
    bottom: 0;
    right: 20%;
    background-color: ${(props) => props.theme.colors.primary};
    padding: 0.5rem 1rem 0.8rem 1rem;
    z-index: 999;
    a {
      color: #FFFFFF;
      text-decoration: none;
      border-bottom: 1px solid #FFFFFF;
      font-family: ${(props) => props.theme.fontCondensed};
    }
  `
 

  

   

  return (
    <Foot>
      <FutureButton>
        <a href="/future">The Future</a>
      </FutureButton>
      <Wrapper>
        
        <ContainerRowTop>
          <div className="mobile-sub">
              <Subscribe />
          </div>
          <TopFooter>
            <ul>
              <li>GETTING HERE</li>
              <li>Shepherd’s Bush Market</li>
              <li>Uxbridge Road</li>
              <li>Shepherd’s Bush</li>
              <li>London W12 8DF</li>
              <li><a href="https://goo.gl/maps/hgb6n9ZhbY7d8pCK9" target="_blank" className="underline">View on Google Maps</a></li>
              <br/>
              <li>Entrances on Uxbridge Road</li>
              <li>and Goldhawk Road</li>
            </ul>
            <ul>
              <li>USEFUL LINKS</li>
              <li><Link to="/visiting/">Plan your visit</Link></li>
              <li><Link to="/trader-directory/">Trader directory</Link></li>
              <li><Link to="/about/">About us</Link></li>
              <li><Link to="/about/#contacts">Contact us</Link></li>
              <li><Link to="/future">The Future</Link></li>
              <br />
              <li><Link to="/spaces/#trader">Apply to Trade</Link></li>
              <li><Link to="/spaces/#location">Apply to Film</Link></li>
            </ul>
            <ul>
              <li>OPENING TIMES</li>
              <li className="opening">{data.contentfulOpeningTimes.openingTimes.openingTimes}</li>
              <br />
              <li>See hours for</li>
              <li><Link to="/trader-directory/" className="underline">individual shops</Link></li>
            </ul>
            <ul>
              <li>FOLLOW US</li>
              <li><a href="https://www.instagram.com/shepherdsbushmarket/?hl=en" target="_blank">Instagram</a></li>
              <li><a href="https://twitter.com/myshepherdsbush?lang=en " target="_blank">Twitter</a></li>
              <li><a href="https://www.facebook.com/myshepherdsbushmarket/" target="_blank">Facebook</a></li>
            </ul>
          </TopFooter>
        </ContainerRowTop>
        <ContainerRow>
          <ThirdPageFootLeft>
            <Link to="/" aria-label="Home">
                <Logo />
            </Link>
          </ThirdPageFootLeft>
          <ThirdPageFootRight>
            <Links>
              <li>
                <Link className="last-link" to="/">©2021 YC SHEPHERDS BUSH (MARKET) LTD</Link>
              </li>
              <li>
                <Link to="/privacy-policy">PRIVACY POLICY</Link>
              </li>
              <li>
                <Link to="/cookie-policy">TERMS</Link>
              </li>
              <li>
                <Link className="last-link" to="https://www.polytechnic.works/">SITE CREDIT</Link>
              </li>
              <li>
                <a className="last-link" href="mailto:info@shepherdsbushmarket.org">INFO@SHEPHERDSBUSHMARKET.ORG</a>
              </li>
            </Links>
          </ThirdPageFootRight>
          <ThirdPage className="sub">
            <div className="desktop-sub">
              <Subscribe />
            </div>
          </ThirdPage>
        </ContainerRow>

      </Wrapper>
    </Foot>
  );
}

export default withTheme(Footer)
